import Vue from 'vue'
import App from './App.vue'
import './assets/styles.css'
import 'materialize-css/dist/css/materialize.css'
import './plugins/AudioVisual/'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
